import { useNavigate, useParams } from "react-router-dom";
import { getListLineAssociate } from "../../../Stores/Box/Slice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Card } from "antd";
import List from "../../../Commons/BasicModule/List";

// No Edit 
const tableField = ['name', 'description', 'status', 'start_date', 'end_date', 'box_id', 'inteface']
const columnTable = tableField.map((field) => ({
    title: field,
    dataIndex: field,
    key: field,
}))

const LineAssociate = () => {
    const dispatch = useDispatch();
     const navigate = useNavigate();
    const { id } = useParams();
    const [lines, setLines] = useState([]);
    useEffect(() => {
        // Get Detail Box with ID
        dispatch(getListLineAssociate(id)).then(res => {
            const { data } = res.payload
            setLines(data)
        })
    }, [id])

    const onEditEvent = (record) => {
        navigate("/line/"+record.id)
    }

    return <Card
        style={{
            marginTop: 4,
        }}
        type="inner"
        title="Line Associate with Box"
        loading={!(lines.length)}
    >
        <List
            columnTable={columnTable}
            dataList={lines}
            onEditEvent={onEditEvent}
        />
    </Card>
}

export default LineAssociate